import { render, staticRenderFns } from "./Produccion_Aceite.vue?vue&type=template&id=286fd0ea&scoped=true&"
import script from "./Produccion_Aceite.vue?vue&type=script&lang=js&"
export * from "./Produccion_Aceite.vue?vue&type=script&lang=js&"
import style0 from "./Produccion_Aceite.vue?vue&type=style&index=0&id=286fd0ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286fd0ea",
  null
  
)

export default component.exports